// extracted by mini-css-extract-plugin
export default {"form":"AdminLogin_form__XFGO8","title":"AdminLogin_title__laBNj","input":"AdminLogin_input__NtMBL","button":"AdminLogin_button__rMBty","error":"AdminLogin_error__R4gvm"};